<template>
    <div class="liang-wrapper">
        <div class="chart-item">
            <p>混凝土</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月销量(方):<span>{{ hntTotal.byxl }}</span>
                </div>
                <div class="total-item">
                    年累计销量(方):<span>{{ hntTotal.bnxl }}</span>
                </div>
            </div>
            <div id="hntChart" class="chart-wrapper hntChart"></div>
        </div>
        <div class="chart-item">
            <p>砂浆</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月销量(方):<span>{{ sjTotal.byxl }}</span>
                </div>
                <div class="total-item">
                    年累计销量(方):<span>{{ sjTotal.bnxl }}</span>
                </div>
            </div>
            <div id="sjChart" class="chart-wrapper sjChart"></div>
        </div>
    </div>
</template>

<script>
import bg_blue from '../../../assets/images/home/bg_blue.png';
import bg_orange from '../../../assets/images/home/bg_orange.png';
import { Toast } from 'vant';
export default {
    data() {
        return {
            hntData: [],
            sjData: [],
            hntTotal: {},
            sjTotal: {},
            Year: '',
            Month: '',
        };
    },
    created() {
        this.Year = new Date().getFullYear();
        this.Month = new Date().getMonth() + 1;
    },
    mounted() {
        this.getStatistics(0);
        this.getStatistics(1);

        this.getTotal(0);
        this.getTotal(1);
    },
    methods: {
        getTotal(type) {
            this.$axios
                .get('/interfaceApi/report/largescreen/qty/tj/' + this.Year + '/' + this.Month + '/' + type)
                .then(res => {
                    if (type === 0) {
                        this.hntTotal = res;
                    } else {
                        this.sjTotal = res;
                    }

                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getStatistics(type) {
            // Toast.loading({
            //     message: '加载中...',
            //     forbidClick: true,
            // });
            this.$axios
                .get('/interfaceApi/report/largescreen/qty/' + this.Year + '/' + this.Month + '/' + type)
                .then(res => {
                    // Toast.clear();
                    if (type === 0) {
                        this.hntData = res;
                        this.hntChart();
                    } else {
                        this.sjData = res;
                        this.sjChart();
                    }

                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        sjChart() {
            const myChart = this.$echarts.init(document.getElementById('sjChart'));
            const xdata = [];
            const data = [];
            this.sjData.forEach(item => {
                xdata.push(item.xsy + '月');
                data.push(item.xsl);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '20%',
                    bottom: '12%',
                    right: '0%',
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(方)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#F98F48',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 10, 4, 10],
                        backgroundColor: {
                            image: bg_orange,
                        },
                    },
                    barWidth: 20,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#EFAB54', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#FA8C47', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
        hntChart() {
            const myChart = this.$echarts.init(document.getElementById('hntChart'));
            const xdata = [];
            const data = [];
            this.hntData.forEach(item => {
                xdata.push(item.xsy + '月');
                data.push(item.xsl);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '20%',
                    bottom: '12%',
                    right: '0%',
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(方)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: 'hill',
                    type: 'pictorialBar',
                    barCategoryGap: '0%',
                    symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#449FF3',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        // width: 38,
                        height: 20,
                        align: 'center',
                        lineHeight: 18,
                        padding: [0, 10, 4, 10],
                        backgroundColor: {
                            image: bg_blue,
                        },
                    },
                    barWidth: 50,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#3e79c5', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#55a7fe', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .liang-wrapper
        // margin-top 20rpx
        .chart-item
            padding 15rpx
            background #ffffff
            &:last-child
                margin-top 15rpx
            p
                font-size 16rpx
                font-weight 600
                color rgba(51,51,51,1)
                line-height 36px
            .total-wrapper
                display flex
                justify-content space-between
                .total-item
                    width 150rpx
                    height 30rpx
                    border 2rpx solid rgba(234,234,234,1)
                    font-size 10rpx
                    line-height 26rpx
                    text-align center
                    span
                        font-size 14rpx
                        line-height 26rpx
                    &:first-child
                        span
                            color #4486D5
                    &:last-child
                        span
                            color #F8924A
            .chart-wrapper
                height 200rpx
                width 100%
</style>